import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { Course } from '../types';
import { getCourseQuery, GetCourseQueryResult, GetCourseQueryVariables } from '../graphql/queries/getCourseQuery';

type CourseHookResult = DataFetcherHookResult<Course, 'course'>;

interface CourseHookInput {
  courseId: string;
}

export default function useCourse(input: CourseHookInput): CourseHookResult {
  const { courseId } = input;
  const { data, loading, error } = useQuery<GetCourseQueryResult, GetCourseQueryVariables>(getCourseQuery, { variables: { courseId } });

  return { loading, error: getErrorMessage({ error }), course: data?.course };
}
